import React, { useEffect, useState } from 'react';
import '../../components/PipeCategories/ERWPipe.css';
import { getEnds, getFinishes, getSpecifications, getLengths, getLengthValues, getPaymentTerms, getDeliveryTimes, getProductDetails, postEnquiry, getAllBrandsByProduct, getCategoryDetail } from '../../API/Api';
import { useParams, useLocation } from 'react-router-dom';
import { getAuthToken } from "../../utils/auth";
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";

const ERWPipe = ({ }) => {
	const { slug } = useParams();
	const location = useLocation();
	const [originalItem, setOriginalItem] = useState(null);
	const [product, setProduct] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [token, setToken] = useState(null);
	const [formData, setFormData] = useState({
		size: '',
		product_id: '',
		wt: '',
		finish: '',
		finishOther: '',
		specification: '',
		end: '',
		length: '',
		lengthOptions: '',
		lengthOther: '',
		brand: [],
		priceBasis: '',
		quantity: '',
		quantityUnit: 'KG',
		address: '',
		pincode: '',
		payment: '',
		delivery: '',
		deliveryOther: '',
		paymentDetails: '',
		advanceValue: '',
		advanceType: 'percentage',
		restDays: '',
		paymentDays: '',
		category_id: ''
	});
	console.log("ERW:::----", formData)

	const [items, setItems] = useState([]);
	const [dropdownData, setDropdownData] = useState({
		finishes: [],
		specifications: [],
		ends: [],
		lengths: [],
		lengthValues: [],
		deliveryTimes: []
	});
	const [showFinishOther, setShowFinishOther] = useState(false);
	const [showLengthOptions, setShowLengthOptions] = useState(false);
	const [showLengthOther, setShowLengthOther] = useState(false);
	const [lengthInfo, setLengthInfo] = useState('');
	const [brands, setBrands] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [showDeliveryOther, setShowDeliveryOther] = useState(false);
	const [paymentTerms, setPaymentTerms] = useState([]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [editingRow, setEditingRow] = useState(null);

	const handleEdit = (index) => {
		if (editingRow === index) {
			cancelEdit();
			return;
		}
		setOriginalItem({ ...items[index] });
		setEditingRow(index);
	};

	const updateItemField = (index, field, value) => {
		setItems(prev => prev.map((item, i) =>
			i === index ? { ...item, [field]: value } : item
		));
	};

	const cancelEdit = () => {
		if (originalItem && editingRow !== null) {
			setItems(prev => prev.map((item, i) =>
				i === editingRow ? originalItem : item
			));
		}
		setEditingRow(null);
		setOriginalItem(null);
	};


	const saveEdit = (index) => {
		setEditingRow(null);
		setOriginalItem(null);
		toast.success("Item updated successfully");
	};

	const toggleDropdown = (e) => {
		e.stopPropagation();
		setIsOpen(!isOpen);
	};

	const closeDropdown = () => setIsOpen(false);

	React.useEffect(() => {
		document.addEventListener('click', closeDropdown);
		return () => document.removeEventListener('click', closeDropdown);
	}, []);

	useEffect(() => {
		setToken(getAuthToken());
	}, []);

	useEffect(() => {
		const fetchCategoryAndProduct = async () => {
			try {
				console.log('Fetching category with slug:', slug);
				const response = await getCategoryDetail(slug);
				console.log('API Response category detail:', response);

				if (response.status && response.data) {
					const categoryData = response.data || {};
					const productData = response.product_details || {};

					setProduct({
						...productData,
						image: productData.image ||

							(categoryData.img ?
								`${process.env.REACT_APP_API_URL}/storage/${categoryData.img}` :
								'path/to/fallback/image.jpg'),
						short_desc: productData.short_desc || '',
						name: productData.name || categoryData.name || '',
						product_id: productData.id || '',
						category_id: categoryData.id || ''
					});

					setFormData(prev => ({
						...prev,
						product_id: productData.id?.toString() || '',
						category_id: categoryData.id?.toString() || ''
					}));
				} else {
					setError(response.message || 'Category data not found');
				}
			} catch (err) {
				console.error('API Error:', err);
				setError(err.message || 'Failed to fetch category details');
			} finally {
				setLoading(false);
			}
		};

		fetchCategoryAndProduct();
	}, [slug]);

	useEffect(() => {
		const fetchAllDropdownData = async () => {
			if (!formData.category_id) return;

			try {
				const categoryResponse = await getCategoryDetail(slug);
				const rawSpec = categoryResponse.data?.specification || '';
				const parsedSpecs = rawSpec.split(',').map(spec => spec.trim()).filter(Boolean);
				const [finishes, ends, lengths, deliveryTimes] = await Promise.all([
					getFinishes(formData.category_id),
					getEnds(formData.category_id),
					getLengths(formData.category_id),
					getDeliveryTimes(),
				]);

				setDropdownData(prev => ({
					...prev,
					finishes,
					specifications: parsedSpecs,
					ends,
					lengths,
					deliveryTimes,
					lengthValues: []
				}));
			} catch (error) {
				console.error("Error fetching dropdown data:", error);
			}
		};

		fetchAllDropdownData();
	}, [formData.category_id, slug]);

	useEffect(() => {
		const fetchBrands = async () => {
			try {
				if (product?.slug) {
					console.log('Product slug for brands API:', product.slug);
					const response = await getAllBrandsByProduct(product.slug);

					if (response.status) {
						setBrands(response.data);
					} else {
						console.error("Failed to fetch brands:", response.message);
					}
				}
			} catch (error) {
				console.error("Error fetching brands:", error);
				setError("Failed to load brands");
			}
		};

		if (product?.slug) {
			fetchBrands();
		}
	}, [product?.slug]);

	useEffect(() => {
		const fetchPaymentTerms = async () => {
			try {
				const response = await getPaymentTerms();
				if (response.status) {
					setPaymentTerms(response.data);
				}
			} catch (error) {
				console.error("Error fetching payment terms:", error);
			}
		};

		fetchPaymentTerms();
	}, []);

	useEffect(() => {
		if (formData.length) {
			if (formData.length === '3') {
				setShowLengthOther(true);
				setShowLengthOptions(false);
			} else {
				const fetchLengthValues = async () => {
					try {
						const values = await getLengthValues(formData.length, formData.category_id);
						setDropdownData(prev => ({
							...prev,
							lengthValues: values
						}));
						setShowLengthOptions(values.length > 0);
						setShowLengthOther(false);
					} catch (error) {
						console.error("Error fetching length values:", error);
					}
				};

				if (formData.category_id) {
					fetchLengthValues();
				}
			}
		} else {
			setDropdownData(prev => ({
				...prev,
				lengthValues: []
			}));
			setShowLengthOptions(false);
			setShowLengthOther(false);
		}
	}, [formData.length, formData.category_id]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData(prev => ({
			...prev,
			[name]: value
		}));

		if (name === 'finish') {
			setShowFinishOther(value === 'Other');
		}

		if (name === 'delivery') {
			setShowDeliveryOther(value === 'Others');
		}

		if (name === 'length') {
			setShowLengthOptions(false);
			setShowLengthOther(false);
			setFormData(prev => ({ ...prev, lengthOptions: '' }));

			if (value === '1' || value === '2') {
				setLengthInfo(`${value} – ${value === '1' ? "Single Random Length" : "Double Random Length"}`);
				setShowLengthOptions(true);
			} else if (value === '3') {
				setShowLengthOptions(false);
				setLengthInfo("** Please specify specific length(m) range if required.");
				setShowLengthOther(true);
			} else {
				setLengthInfo('');
			}
		}
	};


	const validateWT = (e) => {
		const value = e.target.value;
		setFormData(prev => ({ ...prev, wt: value }));
	};

	const validateOtherLength = (e) => {
		let value = parseFloat(e.target.value);
		if (value > 12) value = 12;
		if (value < 1) value = 1;
		setFormData(prev => ({ ...prev, lengthOther: value }));
	};

	const enforceSixDigitLimit = (e) => {
		if (e.target.value.length > 6) {
			setFormData(prev => ({ ...prev, pincode: e.target.value.slice(0, 6) }));
		}
	};

	const validateQuantity = (e) => {
		let value = parseFloat(e.target.value);
		if (value < 0.01) value = 0.01;
		setFormData(prev => ({ ...prev, quantity: value }));
	};

	const handleBrandChange = (e) => {
		const { value, checked, dataset } = e.target;
		const brandId = dataset.id;
		const brandName = value;

		setFormData(prev => {
			let newBrands;
			if (checked) {
				newBrands = [...prev.brand, { id: brandId, name: brandName }];
			} else {
				newBrands = prev.brand.filter(item => item.id !== brandId);
			}

			return {
				...prev,
				brand: newBrands
			};
		});
	};

	const addItem = () => {
		const {
			size, wt, finish, finishOther, specification, end, length,
			lengthOptions, lengthOther, brand, priceBasis, quantity, quantityUnit,
			category_id, product_id
		} = formData;

		if (!size || !wt || !finish || !specification || !end || !length ||
			brand.length === 0 || !quantity || !quantityUnit || !priceBasis) {
			toast.error("Please fill all required fields.");
			return;
		}

		let lengthFinal;
		if (length === '3') {
			if (!lengthOther) {
				toast.error("Please specify length value");
				return;
			}
			lengthFinal = lengthOther;
		} else {
			if (!lengthOptions) {
				toast.error("Please select length option");
				return;
			}
			lengthFinal = lengthOptions;
		}

		const finalFinish = finish === 'Other' ? finishOther :
			document.getElementById('finish').options[document.getElementById('finish').selectedIndex].text;

		const newItem = {
			size,
			wt,
			finish: finalFinish,
			specification,
			end,
			length,
			lengthFinal,
			brand,
			priceBasis,
			quantity,
			quantityUnit,
			category_id,
			product_id,
			finishOther: finish === 'Other' ? finishOther : ''
		};

		setItems(prev => [...prev, newItem]);
		clearInputs();
	};

	const removeItem = (index, e) => {
		e.stopPropagation();
		if (window.confirm("Are you sure you want to remove this item?")) {
			setItems(prev => prev.filter((_, i) => i !== index));
		}
	};

	const clearInputs = () => {
		setFormData(prev => ({
			...prev,
			size: '',
			wt: '',
			finish: '',
			finishOther: '',
			specification: '',
			end: '',
			length: '',
			lengthOptions: '',
			lengthOther: '',
			brand: [],
			priceBasis: '',
			quantity: '',
			quantityUnit: 'KG'
		}));
		setShowFinishOther(false);
		setShowLengthOptions(false);
		setShowLengthOther(false);
		setLengthInfo('');
	};

	const submitQuote = async () => {
		if (isSubmitting) return;
		if (items.length === 0) {
			toast.error("Please add at least one item before submitting");
			return;
		}

		const itemsMissingPriceBasis = items.filter(item => !item.priceBasis);
		if (itemsMissingPriceBasis.length > 0) {
			toast.error("Please select Price Basis for all items before submitting");
			return;
		}

		const { address, pincode, payment, delivery, deliveryOther, advanceValue, advanceType, restDays } = formData;

		if (!address || !pincode || !payment || !delivery) {
			toast.error("Please fill address, pincode, payment and delivery details");
			return;
		}

		setIsSubmitting(true);

		try {
			const enquiry_items = items.map((item) => {
				const brandIds = item.brand.length > 0
					? item.brand.map(b => b.id).join(',')
					: null;

				let formattedLength = item.lengthFinal;
				if (item.length !== '3' && !String(item.lengthFinal).includes('m')) {
					formattedLength = `${item.lengthFinal}m`;
				}

				return {
					product_id: item.product_id.toString(),
					brand_id: brandIds,
					size: item.size.toString(),
					wall_thickness: item.wt.toString(),
					finish: item.finish,
					specification: item.specification,
					end: item.end,
					length: formattedLength,
					price_basis: item.priceBasis,
					address: address,
					pincode: pincode,
					universal_qty: item.quantity.toString(),
					quantity_unit: item.quantityUnit,
					finish_other: item.finishOther || '',
					length_other: item.length === '3' ? String(item.lengthFinal) : '',
					message: "Please provide quotation for these items"
				};
			});

			const now = new Date();
			const finalPayload = {
				payment_term: payment,
				category_id: formData.category_id,
				...(payment === 'Advance' && {
					advance_type: advanceType === 'percentage' ? 'Percentage' : 'Fixed Amount',
					advance_payment_value: advanceValue.toString(),
					rest_paid_within_days: restDays?.toString() || ''
				}),
				...(payment !== 'Advance' && formData.paymentDays && {
					payment_term_number_days: formData.paymentDays.toString()
				}),
				enquiry_items,
				shu_start_date_time: now.toISOString(),
				shu_end_date_time: new Date(now.setDate(now.getDate() + 7)).toISOString(),
				delivery_time: delivery === 'Others' ? deliveryOther : delivery,
				address: address,
				pincode: pincode,
				...(delivery === 'Others' && { delivery_time_other: deliveryOther }),
				...(payment !== 'Advance' && formData.paymentDays && {
					payment_term_number_days: formData.paymentDays.toString()
				})
			};

			console.log('Final payload:::---------:', finalPayload);
			const response = await postEnquiry(finalPayload);

			if (response.status) {
				toast.success(`Enquiry submitted successfully!`);
				setItems([]);
				setFormData(prev => ({
					...prev,
					address: '',
					pincode: '',
					payment: '',
					delivery: '',
					deliveryOther: '',
					paymentDays: '',
					advanceValue: '',
					advanceType: 'percentage',
					restDays: ''
				}));
			} else {
				toast.error(response.message || "Enquiry submission failed");
			}
		} catch (error) {
			console.error("Submission error:", error);
			const errorMessage = error.response?.data?.message || error.message || "Submission failed";
			toast.error(errorMessage);
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className="pipe-quote-container-pipe custom-container-side custom-container-upper custom-inner-space">
			<ToastContainer />
			<div className="container-pipe ">
				<div className="right-section-pipe ">
					{product && product.image && (
						<img
							src={product.image}
							alt="Product"
							className="product-image"
							onError={(e) => {
								e.target.onerror = null;
								e.target.src = 'path/to/fallback/image.jpg'
							}}
						/>
					)}
					{error && <div className="error-message">{error}</div>}
					{product && product.short_desc && (
						<div className="product-description-pipe">
							{product.short_desc}
						</div>
					)}
				</div>

				<div className="left-section-pipe">
					<h2 className="custom-heading-pipe">
						{product?.name}
					</h2>

					<input
						type="hidden"
						id="product_id"
						name="product_id"
						value={product?.product_id}
					/>

					<div className="form-column-pipe">
						<label>Size (NB/OD):<span className="required-asterisk">*</span></label>
						<input
							type="text"
							id="size"
							name="size"
							min="10"
							max="10000"
							value={formData.size}
							onChange={handleChange}
							placeholder="e.g., 8mm, 10mm, "
						/>

						<label>Finish:<span className="required-asterisk">*</span></label>
						<select id="finish" name="finish" value={formData.finish} onChange={handleChange}>
							<option value="" disabled>-- Select Finish --</option>
							{dropdownData.finishes.map((finish) => (
								<option key={finish.id} value={finish.name}>
									{finish.name}
								</option>
							))}
						</select>

						{showFinishOther && (
							<input
								type="text"
								id="finishOther"
								name="finishOther"
								placeholder="Specify Other Coating"
								value={formData.finishOther}
								onChange={handleChange}
							/>
						)}

						<label>End:<span className="required-asterisk">*</span></label>
						<select id="end" name="end" value={formData.end} onChange={handleChange}>
							<option value="" disabled>-- Select End --</option>
							{dropdownData.ends.map((end) => (
								<option key={end.id} value={end.name}>
									{end.name}
								</option>
							))}
						</select>

						<div className="dropdown-multiselect">
							<label>Brand/Make:<span className="required-asterisk">*</span></label>
							<div className="erw-dropdown-toggle" onClick={(e) => {
								e.stopPropagation();
								setIsOpen(!isOpen);
							}}>
								<span className="dropdown-arrow">
									{formData.brand.length > 0
										? formData.brand.map(b => b.name).join(", ")
										: "Select Brand / Make"} {isOpen ? '' : ''}
								</span>
								<FaChevronDown />
							</div>
							{isOpen && (
								<div className="erw-dropdown-options" onClick={(e) => e.stopPropagation()}>
									<div className="brand-checkbox-container">
										{brands.map((brand) => (
											<div key={brand.id} className="brand-checkbox-item">
												<input
													type="checkbox"
													id={`brand-${brand.id}`}
													name="brand"
													value={brand.name}
													data-id={brand.id}
													checked={formData.brand.some(b => String(b.id) === String(brand.id))}
													onChange={handleBrandChange}
												/>
												<label htmlFor={`brand-${brand.id}`}>{brand.name}</label>
											</div>
										))}
										{/* <div className="brand-checkbox-item">
											<input
												type="checkbox"
												id="brand-any"
												name="brand"
												value="Not Preferred / Any"
												data-id="0"
												checked={formData.brand.some(b => b.name === "Not Preferred / Any")}
												onChange={handleBrandChange}
											/>
											<label htmlFor="brand-any">
												Not Preferred / Any
											</label>
										</div> */}
									</div>
								</div>
							)}
						</div>

						{/* <label>Quantity:</label>
            <div className="location-row">
              <input
                type="number"
                id="quantity"
                name="quantity"
                placeholder="Enter Quantity"
                min="0.01"
                step="0.01"
                value={formData.quantity}
                onChange={handleChange}
                onInput={validateQuantity}
              />
              <select
                id="quantityUnit"
                name="quantityUnit"
                value={formData.quantityUnit}
                onChange={handleChange}
              >
                <option value="" disabled>-- Unit --</option>
                <option value="Kg">KG</option>
                <option value="MT">MT</option>
                <option value="Pc">PC</option>
                <option value="Mtrs">MTRS</option>
              </select>
            </div> */}
						{/* <hr /> */}
					</div>

					<div className="form-column-pipe">
						<label>Wall Thickness (WT):<span className="required-asterisk">*</span></label>
						<input
							type="text"
							id="wt"
							name="wt"
							value={formData.wt}
							onChange={validateWT}
						/>

						<label>Specification:<span className="required-asterisk">*</span></label>
						<select
							id="specification"
							name="specification"
							value={formData.specification}
							onChange={handleChange}
						>
							<option value="" disabled>-- Select Specification --</option>
							{dropdownData.specifications.map((spec, index) => (
								<option key={index} value={spec}>
									{spec}
								</option>
							))}
						</select>

						<label>Length:<span className="required-asterisk">*</span></label>
						<select
							id="length"
							name="length"
							value={formData.length}
							onChange={handleChange}
						>
							<option value="" disabled>-- Select Length --</option>
							{dropdownData.lengths.map((item) => (
								<option key={item.id} value={item.id}>
									{item.name}
								</option>
							))}
						</select>
						{showLengthOptions && (
							<select
								id="lengthOptions"
								name="lengthOptions"
								value={formData.lengthOptions}
								onChange={handleChange}
							>
								<option value="" disabled>-- Select Option --</option>
								{dropdownData.lengthValues.map((value) => (
									<option key={value.id} value={value.value}>
										{value.value}
									</option>
								))}
							</select>
						)}

						{showLengthOther && (
							<input
								type="number"
								id="lengthOther"
								name="lengthOther"
								placeholder="Specify Other Length (max 12m)"
								min="1"
								max="12"
								step="0.01"
								value={formData.lengthOther}
								onChange={handleChange}
								onInput={validateOtherLength}
							/>
						)}

						{lengthInfo && <div className="length-info">{lengthInfo}</div>}


						<label>Quantity:<span className="required-asterisk">*</span></label>
						<div className="location-row">
							<input
								type="number"
								id="quantity"
								name="quantity"
								placeholder="Enter Quantity"
								min="0.01"
								step="0.01"
								value={formData.quantity}
								onChange={handleChange}
								onInput={validateQuantity}
							/>
							<select
								id="quantityUnit"
								name="quantityUnit"
								value={formData.quantityUnit}
								onChange={handleChange}
							>
								<option value="" disabled>-- Unit --</option>
								<option value="MT">MT</option>
								<option value="Pc">PC</option>
								<option value="Mtrs">MTRS</option>
								<option value="Kg">KG</option>

							</select>
						</div>
						<div>
							{/* <label>For more specific items:</label> */}
							<button className='button-pipe' onClick={addItem}>Add Item</button>
						</div>

						{/* <hr /> */}
					</div>

					<div className="form-column-pipe row-col-2" style={{ gridColumn: '1 / -1' }}>

						<label>Delivery Location:<span className="required-asterisk">*</span></label>
						<div className="location-row" style={{ display: 'flex', gap: '1rem' }}>
							<input
								type="text"
								id="address"
								name="address"
								placeholder="Enter Delivery Address"
								value={formData.address}
								onChange={handleChange}
							/>
							<input
								type="number"
								id="pincode"
								name="pincode"
								placeholder="Enter Pincode"
								min="100000"
								max="999999"
								value={formData.pincode}
								onChange={handleChange}
								onInput={enforceSixDigitLimit}
							/>
						</div>

					</div>

					<div className="form-column-pipe" style={{ gridColumn: '1 / -1' }}>
						<div style={{ display: 'flex', gap: '1rem' }}>
							<div style={{ flex: 1 }}>
								<label>Payment Terms:<span className="required-asterisk">*</span></label>
								<select
									name="payment"
									value={formData.payment}
									onChange={handleChange}
									style={{ width: '100%' }}
								>
									<option value="">Select payment term</option>
									{paymentTerms.map((term) => (
										<option key={term.id} value={term.name.trim()}>
											{term.name.trim()}
										</option>
									))}
								</select>
							</div>

							{formData.payment === 'Advance' && (
								<>
									<div style={{ flex: 1 }}>
										<label style={{ whiteSpace: 'nowrap', display: 'inline-block' }}>Advance Payment Value:<span className="required-asterisk">*</span></label>
										<input
											type="number"
											name="advanceValue"
											value={formData.advanceValue}
											onChange={handleChange}
											placeholder="Enter Value"

											style={{ width: '100%' }}
										/>
									</div>

									<div style={{ flex: 1 }}>
										<label>Advance Type:<span className="required-asterisk">*</span></label>
										<select
											name="advanceType"
											value={formData.advanceType}
											onChange={handleChange}
											style={{ width: '100%' }}
										>
											<option value="percentage">Percentage</option>
											<option value="fixed">Fixed Amount</option>
										</select>
									</div>

									<div style={{ flex: 1 }}>
										<label style={{ whiteSpace: 'nowrap', display: 'inline-block' }}>Rest paid (Specify Here):<span className="required-asterisk">*</span></label>
										<input
											type="text"
											name="restDays"
											value={formData.restDays || ''}
											onChange={handleChange}
											placeholder="Rest paid within days"
											min={1}
											style={{ width: '100%' }}
										/>
									</div>
								</>
							)}

							{formData.payment && formData.payment !== 'Advance' && (
								<div style={{ flex: 1 }}>
									<label>Enter number of days<span className="required-asterisk">*</span></label>
									<input
										type="number"
										name="paymentDays"
										value={formData.paymentDays || ''}
										onChange={handleChange}
										placeholder="Number of days"
										style={{ width: '100%' }}
									/>
								</div>
							)}
						</div>
					</div>

					<div className="form-grid-two-cols">
						<div className="form-half">
							<label>Delivery Time:<span className="required-asterisk">*</span></label>
							<select
								id="delivery"
								name="delivery"
								value={formData.delivery}
								onChange={handleChange}
							>
								<option value="" disabled>-- Select Delivery Time --</option>
								{dropdownData.deliveryTimes.map((time) => (
									<option key={time.id} value={time.name}>
										{time.name}
									</option>
								))}
							</select>
							{showDeliveryOther && (
								<input
									type="text"
									id="deliveryOther"
									name="deliveryOther"
									placeholder="Specify Delivery Time"
									value={formData.deliveryOther}
									onChange={handleChange}
								/>
							)}
						</div>

						<div className="form-half">
							<label>Price Basis:<span className="required-asterisk">*</span></label>
							<select
								id="priceBasis"
								name="priceBasis"
								value={formData.priceBasis}
								onChange={handleChange}
								required
							>
								<option value="" disabled>-- Select Price Basis --</option>
								<option>Ex-Factory</option>
								<option>F.O.R.</option>
							</select>
						</div>
					</div>
					<div id="itemList">
						<h3>
							Items to Quote{' '}
							<span className="item-count">
								{items.length} {items.length === 1 ? 'item' : 'items'}
							</span>
						</h3>
						<table className="items-table">
							<thead>
								<tr>
									<th>SR. NO.</th>
									<th>SIZE</th>
									<th>THICKNESS</th>
									<th>SPECIFICATION</th>
									<th>FINISH</th>
									<th>ENDS</th>
									<th>BRAND</th>
									<th>QUANTITY</th>
									<th>ACTION</th>
								</tr>
							</thead>
							<tbody>
								{items.length > 0 ? (
									items.map((item, index) => (
										<React.Fragment key={index}>
											<tr>
												<td>{index + 1}</td>
												<td>{item.size}</td>
												<td>{item.wt}</td>
												<td>{item.specification}</td>
												<td>{item.finish}</td>
												<td>{item.end}</td>
												<td>
													{item.brand.map(b => b.name).join(", ")}
												</td>
												<td>{item.quantity} {item.quantityUnit}</td>
												<td>
													<button
														className="remove-btn-pipe"
														onClick={(e) => removeItem(index, e)}
														title="Remove item"
													>
														<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
															<path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
														</svg>
													</button>
													<button
														className="edit-btn-pipe"
														onClick={() => handleEdit(index)}
														title="Edit item"
													>
														<MdEdit />
													</button>
												</td>

											</tr>
											{editingRow === index && (
												<tr className="edit-form-row">
													<td colSpan="9">
														<div className="edit-form-container">
															<div className="edit-form-columns">
																<div className="edit-form-column">
																	<label>Size (NB/OD):</label>
																	<input
																		type="text"
																		value={item.size}
																		onChange={(e) => updateItemField(index, 'size', e.target.value)}
																	/>

																	<label>Wall Thickness (WT):</label>
																	<input
																		type="text"
																		value={item.wt}
																		onChange={(e) => updateItemField(index, 'wt', e.target.value)}
																	/>

																	<label>Specification:</label>
																	<select
																		id="specification"
																		name="specification"
																		value={formData.specification}
																		onChange={handleChange}
																	>
																		<option value="" disabled>-- Select Specification --</option>
																		{dropdownData.specifications.map((spec, index) => (
																			<option key={index} value={spec}>
																				{spec}
																			</option>
																		))}
																	</select>
																</div>

																<div className="edit-form-column">
																	<label>Finish:</label>
																	<select
																		value={item.finish}
																		onChange={(e) => updateItemField(index, 'finish', e.target.value)}
																	>
																		<option value="">-- Select --</option>
																		{dropdownData.finishes.map((finish) => (
																			<option key={finish.id} value={finish.name}>
																				{finish.name}
																			</option>
																		))}
																	</select>

																	<label>End:</label>
																	<select
																		value={item.end}
																		onChange={(e) => updateItemField(index, 'end', e.target.value)}
																	>
																		<option value="">-- Select --</option>
																		{dropdownData.ends.map((end) => (
																			<option key={end.id} value={end.name}>
																				{end.name}
																			</option>
																		))}
																	</select>
																	<label className='edit-form-labelAngle'>Brand/Make:</label>
																	<div className='erw-dropdown-toggle'>
																		<div className="brand-checkbox-container dropdown-multiselect ">
																			{brands.map((brand) => (
																				<div key={brand.id} className="brand-checkbox-item  ">
																					<input
																						type="checkbox"
																						id={`edit-brand-${brand.id}-${index}`}
																						checked={item.brand.some(b => String(b.id) === String(brand.id))}
																						onChange={(e) => {
																							const newBrands = e.target.checked
																								? [...item.brand, { id: brand.id, name: brand.name }]
																								: item.brand.filter(b => String(b.id) !== String(brand.id));
																							updateItemField(index, 'brand', newBrands);
																						}}
																					/>
																					<label htmlFor={`edit-brand-${brand.id}-${index}`}>{brand.name}</label>
																				</div>
																			))}
																		</div>
																	</div>
																	<label>Quantity:</label>
																	<div className="edit-quantity-row">
																		<input
																			type="number"
																			value={item.quantity}
																			onChange={(e) => updateItemField(index, 'quantity', e.target.value)}
																		/>
																		<select
																			value={item.quantityUnit}
																			onChange={(e) => updateItemField(index, 'quantityUnit', e.target.value)}
																		>
																			<option value="Kg">KG</option>
																			<option value="MT">MT</option>
																			<option value="Pc">PC</option>
																			<option value="Mtrs">MTRS</option>
																		</select>
																	</div>
																</div>
															</div>

															<div className="edit-form-buttons">
																<button
																	className="button-pipe save-edit-btn"
																	onClick={() => saveEdit(index)}
																>
																	Save Changes
																</button>
																<button
																	className="button-pipe cancel-edit-btn"
																	onClick={cancelEdit}
																>
																	Cancel
																</button>
															</div>
														</div>
													</td>
												</tr>
											)}
										</React.Fragment>
									))
								) : (
									<tr>
										<td colSpan="9" style={{ textAlign: 'center' }}>No items added.</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
					<button
						className='button-pipe'
						onClick={submitQuote}
						disabled={isSubmitting}
					>
						{isSubmitting ? (
							<>
								<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Processing...
							</>
						) : (
							"Send for Quote"
						)}
					</button>
				</div>
			</div>
		</div>
	);
};

export default ERWPipe;